import React, { useState, useContext, useEffect } from 'react';
import { StyleSheet, Text, View, TouchableOpacity, ScrollView, Dimensions, Switch, Platform } from 'react-native';

import { RadioButton } from 'react-native-paper'
import { useFonts } from 'expo-font';

import AsyncStorage from '@react-native-async-storage/async-storage';
import { CredentialsContext } from '../components/CredentialsContext';

import StyledText from '../components/StyledText';

import { EnglishStrings } from '../strings/English';
import { PersianStrings } from '../strings/Persian';
import { ArabicStrings } from '../strings/Arabic';
import { color } from '@rneui/base';

const Settings = props => {

    const {storedCredentials, setStoredCredentials} = useContext(CredentialsContext);

    const [theme, setTheme] = useState(storedCredentials.theme == 'light' ? 'light' : 'dark')
    const [language, setLanguage] = useState(storedCredentials.language ? storedCredentials.language : 'Persian') 
    const [offlineUsage, setOfflineUsage] = useState(()=> {
        if(storedCredentials.offlineUsage){
            if(storedCredentials.offlineUsage == true) return true
            else return false
        } else {
            return false
        }
    })
    let [fontsLoaded] = useFonts({
        "Mikhak-Bold": require('../assets/Fonts/Mikhak-Bold.ttf')
    })

    const strings = () => {
        if(language == 'English') {
            return EnglishStrings
        } else if(language == 'Arabic') {
            return ArabicStrings 
        } else {
            return PersianStrings
        }
    }

    useEffect(() => {
        //console.log(storedCredentials)
        props.navigation.setOptions({
            headerTitle: strings().settings,
            headerTitleAlign: 'center',
            headerTitleStyle:{
                fontSize: 35,
                fontFamily: "Mikhak-Bold"
            },
            headerStyle:{
                backgroundColor: theme == "light" ? '#f2f2f2' : '#3b3c37' 
            },
            headerTintColor: theme == "light" ? 'black' : 'white' 
        })
    },[theme, language])

    const changeLanguageHandler = targetLanguage => {
        if(language != targetLanguage) {
            const updatedStoredCredentials = {...storedCredentials, ...{language: targetLanguage}}

            AsyncStorage.setItem('flowerCribCredentials', JSON.stringify(updatedStoredCredentials))
            .then(()=> {
                setStoredCredentials(updatedStoredCredentials)
            })
            .catch(err =>{
                console.log(err);
            })        
            
            setLanguage(targetLanguage)
        }
    }

    const offlineUsageChangeHandler = newValue => {
        const updatedStoredCredentials = {...storedCredentials, ...{offlineUsage: newValue}}

        AsyncStorage.setItem('flowerCribCredentials', JSON.stringify(updatedStoredCredentials))
        .then(()=> {
            setStoredCredentials(updatedStoredCredentials)
        })
        .catch(err =>{
            console.log(err);
        })        
        
        setOfflineUsage(newValue)    
    }
    
    return (
        <ScrollView>
            <View style={ theme == "light" ? LightStyles.wrapper : DarkStyles.wrapper }>
                <View style={ theme == "light" ? LightStyles.settingBoxWrapper : DarkStyles.settingBoxWrapper }>
                    
                    <View style={theme == "light" ? LightStyles.settingBoxHeader : DarkStyles.settingBoxHeader}>
                        <StyledText style={theme == "light" ? LightStyles.settingBoxHeaderText : DarkStyles.settingBoxHeaderText}> {strings().theme} </StyledText>
                    </View>

                    <View style={theme == "light" ? LightStyles.themeSettingBoxBody : DarkStyles.themeSettingBoxBody}>
                        <View style={{flexDirection: 'row', justifyContent: 'space-around'}}>
                            <TouchableOpacity 
                                style={{backgroundColor: 'white', borderRadius: 15,alignItems: 'center', justifyContent: 'center', width: '35%', height: 90}}
                                onPress={() => {
                                    if(theme != 'light'){
                                        const updatedStoredCredentials = {...storedCredentials, ...{theme:"light"}}
            
                                        AsyncStorage.setItem('flowerCribCredentials', JSON.stringify(updatedStoredCredentials))
                                        .then(()=> {
                                            setStoredCredentials(updatedStoredCredentials)
                                        })
                                        .catch(err =>{
                                            console.log(err);
                                        })

                                        setTheme('light')

                                    } 
                                }}
                            >
                                <View>
                                    <StyledText style={{fontSize: 20}}> {strings().light} </StyledText>
                                </View>
                            </TouchableOpacity>

                            <TouchableOpacity 
                                style={{backgroundColor: '#121210',borderRadius: 15,alignItems: 'center', justifyContent: 'center', width: '35%', height: 90}}
                                onPress={() => {
                                    if(theme != 'dark'){
                                        const updatedStoredCredentials = {...storedCredentials, ...{theme:"dark"}}
            
                                        AsyncStorage.setItem('flowerCribCredentials', JSON.stringify(updatedStoredCredentials))
                                        .then(()=> {
                                            setStoredCredentials(updatedStoredCredentials)
                                        })
                                        .catch(err =>{
                                            console.log(err);
                                        })

                                        setTheme('dark')

                                    } 
                                }}
                            >
                                
                                <View>
                                    <StyledText style={{fontSize: 20, color: 'white'}}> {strings().dark} </StyledText>
                                </View>
                            </TouchableOpacity>
                        </View>
                    </View>
                </View>

                <View style={ theme == "light" ? LightStyles.settingBoxWrapper : DarkStyles.settingBoxWrapper }>
                    
                    <View style={theme == "light" ? LightStyles.settingBoxHeader : DarkStyles.settingBoxHeader}>
                        <StyledText style={theme == "light" ? LightStyles.settingBoxHeaderText : DarkStyles.settingBoxHeaderText}> {strings().language} </StyledText>
                    </View>

                    <View style={theme == "light" ? LightStyles.themeSettingBoxBody : DarkStyles.themeSettingBoxBody}>
                        <View style={{flexDirection: 'column', justifyContent: 'space-around'}}>
                                <View style={{flexDirection: 'row', alignItems: 'center'}} >
                                    <RadioButton 
                                        value='English'
                                        status={ language == 'English' ? 'checked' : 'unchecked'}
                                        onPress={()=> changeLanguageHandler('English')}
                                    />
                                    <StyledText style={{color: theme == 'light' ? 'black' : 'white', fontSize: 20}}> English </StyledText>
                                </View> 
                                <View style={{flexDirection: 'row', alignItems: 'center'}} >
                                    <RadioButton 
                                        value='فارسی'
                                        status={ language == 'Persian' ? 'checked' : 'unchecked'}
                                        onPress={()=> changeLanguageHandler('Persian')}
                                    /> 
                                    <StyledText style={{color: theme == 'light' ? 'black' : 'white', fontSize: 20}}> فارسی </StyledText>
                                </View>
                                <View style={{flexDirection: 'row', alignItems: 'center'}} >
                                    <RadioButton 
                                        value='العربیه'
                                        status={ language == 'Arabic' ? 'checked' : 'unchecked'}
                                        onPress={()=> changeLanguageHandler('Arabic')}
                                    />
                                    <StyledText style={{color: theme == 'light' ? 'black' : 'white', fontSize: 20}}> العربیه </StyledText>
                                </View>


                        </View>
                    </View>
                </View>
                
                {Platform.OS !== 'web' && 
                    <View style={ theme == "light" ? LightStyles.settingBoxWrapper : DarkStyles.settingBoxWrapper }>
                        
                        <View style={{...theme == "light" ? LightStyles.settingBoxHeader : DarkStyles.settingBoxHeader, ...{flexDirection: 'row-reverse', justifyContent: 'space-between'}}}>
                            <StyledText style={theme == "light" ? LightStyles.settingBoxHeaderText : DarkStyles.settingBoxHeaderText}> {strings().offlineUsage} </StyledText>
                            <Switch 
                                style={{marginLeft: 10}}
                                trackColor={{false: 'gray', true: '#81b0ff'}}
                                thumbColor={offlineUsage ? 'white' : '#f4f3f4'}
                                value={offlineUsage}
                                onValueChange={newValue => offlineUsageChangeHandler(newValue)}
                            />
                        </View>
                    </View>
                
                }
            </View>
        
        </ScrollView>
    )
};

let DarkStyles = {
    wrapper:{
        flex: 1,
        minHeight: Dimensions.get('window').height,
        backgroundColor: '#3b3c37'
    },
    settingBoxWrapper:{
        marginTop: 5,
        marginBottom: 10
    },
    settingBoxHeader:{
        backgroundColor: '#767773', 
        marginBottom: 10
    },
    settingBoxHeaderText:{
        fontSize: 20,
        marginHorizontal: 15,
        color: 'white'
    },
    themeSettingBoxBody:{

    }

}

let LightStyles = {
    wrapper:{
        flex: 1
    },
    settingBoxWrapper:{
        marginTop: 5,
        marginBottom: 10
    },
    settingBoxHeader:{
        backgroundColor: '#4aa4db', 
        marginBottom: 10
    },
    settingBoxHeaderText:{
        fontSize: 20,
        marginHorizontal: 15,
        color: 'white'
    },
    themeSettingBoxBody:{

    }

}

export default Settings;